export class ServiceConfig {
  static host = "https://socialnet.vnpt.vn/api";
  static host_socket = "https://socialnet.vnpt.vn/";
  static hostImage = "https://socialnet.vnpt.vn//api";

  static apiPublicKey =
    "CaMJkTABntHUF2t6KzRNysreTyxKbcaDGbnLZHXC6Nfk2qp7WbW9pT3Tc3LFZ8Fp";
  static linkNews =
    "https://docs.google.com/spreadsheets/d/1ua17qV_3rVPQjYfNSNBCR2nYGx9ALn-lzUvFwTSzT8U/edit#gid=938322973 ";
  static domain = "https://socialnet.vnpt.vn/";
  //static domain = 'http://localhost:4200';
  static topicList = [
    {
      id: "5f1564d970fe37ad07990f3a",
      itemName: "Viettel",
      value: "Viettel",
      pageId: "422989394439237",
    },
    {
      id: "5f1518cc5c154b35ba33fd61",
      itemName: "MobiFone",
      value: "MobiFone",
      pageId: "166007636835093",
    },
    {
      id: "5f55d5b041afb5e9e38f2e26",
      itemName: "VietnamMobile",
      value: "VietnamMobile",
      pageId: "152024624847190",
    },
    {
      id: "5ef00b85b8ea4c67342dbdf9",
      itemName: "Vinaphone",
      value: "Vinaphone",
      pageId: "109753675772847",
    },
  ];
  static defaultChoiceProjectIds = [
    "5ed705212b052eb4e8519a28",
    "5ee886f0dfc5605fa6ffc463",
    "5ef00b85b8ea4c67342dbdf9",
    "5ef2ceb8b8ea4c67342dc21b",
    "5ef2cf56b8ea4c67342dc21c",
    "5f03d1be39534a390108d826",
    "5f1518cc5c154b35ba33fd61",
    "5f1564d970fe37ad07990f3a",
    "5f55d5b041afb5e9e38f2e26",
  ];
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/service-config.ts